import React, { memo } from 'react';

import { Typography } from 'antd';

interface CopyTextProps {
  /** Slug-like value to be copied (id, email, phone, url). */
  value: string | number | null | undefined;
  /** Optional rendered content; defaults to the stringified value. */
  children?: React.ReactNode;
  className?: string;
  /** Render only the copy icon (no text). */
  iconOnly?: boolean;
}

/**
 * Lightweight click-to-copy wrapper around antd `Typography.Text` `copyable`.
 *
 * Use only on slug-like fields (IDs, emails, phone numbers, URLs) — never on
 * names, titles, or free-form text.
 */
const CopyText: React.FC<CopyTextProps> = ({ value, children, className, iconOnly = false }) => {
  if (value === null || value === undefined || value === '') {
    return <>{children ?? null}</>;
  }

  const text = String(value);

  return (
    <span className={className} onClick={e => e.stopPropagation()}>
      <Typography.Text
        copyable={{
          text,
          tooltips: ['Copiar', 'Copiado!']
        }}
      >
        {iconOnly ? null : (children ?? text)}
      </Typography.Text>
    </span>
  );
};

export default memo(CopyText);
